export const HERO_CONSTANTS = {
  TAG: "Travel",
  DATE: "October 23, 2023",
  TITLE: "Stay Connected Anywhere with Travel eSIMs",
  DESCRIPTION:
    "Learn how travel eSIMs can keep you connected while traveling abroad. Discover the benefits and applications of using eSIM technology for seamless connectivity.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/4567890/pexels-photo-4567890.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Travel eSIMs are revolutionizing the way we stay connected while traveling abroad by offering seamless and convenient connectivity. This guide explores the benefits and applications of eSIM technology for travelers.",
  "From avoiding roaming charges to having multiple profiles on one device, travel eSIMs offer a range of features that can enhance your travel experience. We'll delve into the different eSIM providers and how to use them effectively.",
  "Whether you're a frequent traveler or planning a one-time trip, travel eSIMs provide a reliable solution for staying connected. Let's explore the potential benefits and applications of eSIM technology in travel.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Travel eSIMs",
    content:
      "Travel eSIMs are digital SIM cards that allow you to connect to mobile networks without needing a physical SIM card. These eSIMs can be activated remotely and provide seamless connectivity while traveling abroad.",
  },
  {
    title: "2. Benefits of Using Travel eSIMs",
    content:
      "Travel eSIMs offer several benefits, including avoiding roaming charges, having multiple profiles on one device, and easy activation. These eSIMs provide a convenient and cost-effective solution for staying connected while traveling.",
  },
  {
    title: "3. Applications in Travel",
    content:
      "Travel eSIMs can be used in a variety of travel scenarios, from business trips to vacations. These eSIMs are ideal for travelers who need reliable connectivity without the hassle of changing physical SIM cards.",
  },
  {
    title: "4. Choosing the Right Travel eSIM",
    content:
      "When selecting a travel eSIM, consider factors such as coverage, data plans, and compatibility with your device. Look for eSIM providers that offer flexible plans and reliable service in your travel destination.",
  },
  {
    title: "5. Tips for Using Travel eSIMs",
    content:
      "To get the best results from travel eSIMs, ensure that your device is eSIM-compatible and follow the provider's activation instructions. Keep track of your data usage and choose a plan that meets your connectivity needs.",
  },
  {
    title: "6. Maintenance and Updates",
    content:
      "Keep your eSIM profiles up to date and regularly check for updates from your provider. Ensure that you have a backup plan in case of connectivity issues and stay informed about any changes in eSIM technology.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/4567891/pexels-photo-4567891.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top Travel Gadgets for 2023",
    description:
      "Explore the latest travel gadgets for 2023, from travel eSIMs to portable chargers. Learn how to make your travel experience more convenient and enjoyable.",
  },
  {
    image:
      "https://images.pexels.com/photos/4567892/pexels-photo-4567892.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Stay Connected While Traveling Abroad",
    description:
      "Discover practical tips for staying connected while traveling abroad. Follow our step-by-step guide to ensure seamless connectivity during your trip.",
  },
  {
    image:
      "https://images.pexels.com/photos/4567893/pexels-photo-4567893.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Choosing the Right Connectivity Solutions for Your Travels",
    description:
      "Learn about the different connectivity solutions available for travelers, from travel eSIMs to portable Wi-Fi devices. Understand the benefits and applications of each solution to make informed decisions.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Stay Connected with Travel eSIMs",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/4567894/pexels-photo-4567894.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 Travel Connectivity Trends. All rights reserved",
};
